import { render, staticRenderFns } from "./ApprovalDetailComponent.vue?vue&type=template&id=2851027a"
import script from "./ApprovalDetailComponent.vue?vue&type=script&lang=js"
export * from "./ApprovalDetailComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports